import React from 'react'
import { IoTimeOutline } from "react-icons/io5";
import { BsCalendar2Date } from "react-icons/bs";

export default function PartyDateAndTime({ date, time }) {
    const formatDate = (iso) => {
        if (!iso) return "";
        try {
            return new Date(iso).toLocaleDateString(undefined, {
                day: "2-digit",
                month: "long",
                year: "numeric",
            });
        } catch {
            return iso;
        }
    };

    return (
        <>
            <div className="carnival-booking-datetime">
                <div className="carnival-booking-date-time-wrap">
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
                            <path d="M1.59375 5.03125C1.59375 3.99572 2.43322 3.15625 3.46875 3.15625H13.5313C14.5668 3.15625 15.4062 3.99572 15.4062 5.03125V14.0312C15.4062 15.0668 14.5668 15.9062 13.5312 15.9062H3.46875C2.43322 15.9062 1.59375 15.0668 1.59375 14.0312V5.03125Z" stroke="#4F4F4F" stroke-width="1.25" stroke-linejoin="round" />
                            <circle cx="9.82812" cy="8.20312" r="0.796875" fill="#4F4F4F" />
                            <circle cx="12.4844" cy="8.20312" r="0.796875" fill="#4F4F4F" />
                            <circle cx="9.82812" cy="10.8594" r="0.796875" fill="#4F4F4F" />
                            <circle cx="12.4844" cy="10.8594" r="0.796875" fill="#4F4F4F" />
                            <circle cx="4.51562" cy="10.8594" r="0.796875" fill="#4F4F4F" />
                            <circle cx="7.17188" cy="10.8594" r="0.796875" fill="#4F4F4F" />
                            <circle cx="4.51562" cy="13.5156" r="0.796875" fill="#4F4F4F" />
                            <circle cx="7.17188" cy="13.5156" r="0.796875" fill="#4F4F4F" />
                            <circle cx="9.82812" cy="13.5156" r="0.796875" fill="#4F4F4F" />
                            <path d="M4.25 2.09375V3.15625M12.75 2.09375V3.15625" stroke="#4F4F4F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M15.4062 5.8125H1.59375" stroke="#4F4F4F" stroke-width="1.25" stroke-linejoin="round" />
                        </svg> Date:</span>
                    <strong>
                        {date || "--/--/----"}
                    </strong>
                </div>
                <div className="carnival-booking-date-time-wrap">
                    <span><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M9 2.25C5.27344 2.25 2.25 5.27344 2.25 9C2.25 12.7266 5.27344 15.75 9 15.75C12.7266 15.75 15.75 12.7266 15.75 9C15.75 5.27344 12.7266 2.25 9 2.25Z" stroke="#4F4F4F" stroke-width="1.25" />
                        <path d="M9 4.5V9.5625H12.375" stroke="#4F4F4F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                    </svg> Time:</span>
                    <strong>
                        {time || "--:--"}
                    </strong>
                </div>
            </div>

        </>
    )
}
